import { useForm } from 'react-hook-form'
import { Invoice } from 'types'
import {
  getInvoiceGrandTotal,
  getInvoiceTaxes,
  getInvoiceTotal,
} from '../InvoicesList/invoice_total'
import numeral from 'numeral'
import FinalizeButton from '../InvoicesList/FinalizeButton'
import DeleteButton from '../InvoicesList/DeleteButton'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function InvoiceDetails({ invoice: src }: { invoice: Invoice }) {
  const navigate = useNavigate()
  const [invoice, setInvoice] = useState(src)
  const disabled = true
  const { register } = useForm({
    disabled,
  })

  function routeToHome() {
    navigate('/')
  }

  return (
    <div className="container">
      <div className="row border-bottom mb-3">
        <h2>Invoice #{invoice.id}</h2>
      </div>
      <div className="row">
        <div className="col-md-5">
          <div className="row">
            <h2>Customer</h2>
          </div>
          <div className="row mb-3">
            <label
              htmlFor="customer-firstname"
              className="col-sm-2 col-form-label"
            >
              Firstname
            </label>
            <div className="col-sm-10">
              <input
                {...register('customer-firstname', {
                  disabled,
                  value: invoice.customer?.first_name,
                })}
                type="input"
                className="form-control"
                id="customer-firstname"
              />
            </div>
          </div>
          <div className="row mb-3">
            <label
              htmlFor="customer-lastname"
              className="col-sm-2 col-form-label"
            >
              Lastname
            </label>
            <div className="col-sm-10">
              <input
                {...register('customer-lastname', {
                  disabled,
                  value: invoice.customer?.last_name,
                })}
                type="input"
                className="form-control"
                id="customer-lastname"
              />
            </div>
          </div>
          <div className="row mb-3">
            <label
              htmlFor="customer-address"
              className="col-sm-2 col-form-label"
            >
              Address
            </label>
            <div className="col-sm-10">
              <input
                {...register('address', {
                  disabled,
                  value: invoice.customer?.address,
                })}
                type="input"
                className="form-control"
                id="customer-address"
              />
            </div>
          </div>
          <div className="row mb-3">
            <label
              htmlFor="customer-zipcode"
              className="col-sm-2 col-form-label"
            >
              Zipcode
            </label>
            <div className="col-sm-10">
              <input
                {...register('zip_code', {
                  disabled,
                  value: invoice.customer?.zip_code,
                })}
                type="input"
                className="form-control"
                id="customer-zipcode"
              />
            </div>
          </div>
          <div className="row mb-3">
            <label htmlFor="customer-city" className="col-sm-2 col-form-label">
              City
            </label>
            <div className="col-sm-10">
              <input
                {...register('city', {
                  disabled,
                  value: invoice.customer?.city,
                })}
                type="input"
                className="form-control"
                id="customer-city"
              />
            </div>
          </div>
          <div className="row mb-3">
            <label
              htmlFor="customer-country"
              className="col-sm-2 col-form-label"
            >
              Country
            </label>
            <div className="col-sm-10">
              <input
                {...register('country', {
                  disabled,
                  value: invoice.customer?.country,
                })}
                type="input"
                className="form-control"
                id="customer-country"
              />
            </div>
          </div>
        </div>
        <div className="col-md-2"></div>
        <div className="col-md-5">
          <div className="row">
            <h2>Summary</h2>
          </div>
          <div className="row mb-3">
            <label htmlFor="invoice_id" className="col-sm-2 col-form-label">
              Invoice #
            </label>
            <div className="col-sm-10">
              <input
                {...register('id', {
                  disabled,
                  value: invoice.id,
                })}
                type="input"
                className="form-control"
                id="invoice_id"
              />
            </div>
          </div>
          <div className="row mb-3">
            <label htmlFor="finalized" className="col-sm-2 col-form-label">
              Finalized?
            </label>
            <div className="col-sm-10">
              <select
                disabled={disabled}
                value={String(invoice.finalized)}
                className="form-control"
                id="finalized"
              >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          </div>
          <div className="row mb-3">
            <label htmlFor="paid" className="col-sm-2 col-form-label">
              Paid?
            </label>
            <div className="col-sm-10">
              <select
                {...register('paid', {
                  disabled,
                  value: invoice.paid,
                })}
                className="form-control"
                id="paid"
              >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          </div>
          <div className="row mb-3">
            <label htmlFor="date" className="col-sm-2 col-form-label">
              Created
            </label>
            <div className="col-sm-10">
              <input
                {...register('date', {
                  disabled,
                  value: invoice.date,
                })}
                type="input"
                className="form-control"
                id="date"
              />
            </div>
          </div>
          <div className="row mb-3">
            <label htmlFor="deadline" className="col-sm-2 col-form-label">
              Deadline
            </label>
            <div className="col-sm-10">
              <input
                {...register('deadline', {
                  disabled,
                  value: invoice.deadline,
                })}
                type="input"
                className="form-control"
                id="deadline"
              />
            </div>
          </div>
          <div className="row mb-3">
            <hr />
          </div>

          <div className="row mb-3">
            <label htmlFor="total" className="col-sm-2 col-form-label">
              Price
            </label>
            <div className="col-sm-10">
              <input
                {...register('total', {
                  disabled,
                  value: getInvoiceTotal(invoice),
                })}
                type="number"
                className="form-control"
                id="total"
              />
            </div>
          </div>
          <div className="row mb-3">
            <label htmlFor="tax" className="col-sm-2 col-form-label">
              Tax
            </label>
            <div className="col-sm-10">
              <input
                {...register('tax', {
                  disabled,
                  value: getInvoiceTaxes(invoice),
                })}
                type="number"
                step={0.1}
                className="form-control"
                id="tax"
              />
            </div>
          </div>

          <div className="col">
            <div className="row mb-3">
              <label htmlFor="grand_total" className="col-sm-2 col-form-label">
                <strong>Net price</strong>
              </label>
              <div className="col-sm-10">
                <input
                  {...register('grand_total', {
                    disabled,
                    value: getInvoiceGrandTotal(invoice),
                  })}
                  type="input"
                  className="form-control"
                  id="grand_total"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="row mb-3">
            <h2>Invoice Items</h2>
          </div>
          <div className="row mb-3">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Product #</th>
                  <th>Product name</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>VAT</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {invoice.invoice_lines?.map((line) => (
                  <tr key={line.id}>
                    <td>{line.id}</td>
                    <td>{line.label}</td>
                    <td>
                      {line.quantity} {line.unit}
                    </td>
                    <td>{numeral(line.price).format('$0.00')}</td>
                    <td>
                      {numeral(line.tax).format('$0.00')} ({line.vat_rate}%)
                    </td>
                    <td>
                      <b>
                        {numeral(Number(line.price) + Number(line.tax)).format(
                          '$0.00'
                        )}
                      </b>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-group-divider">
                <tr>
                  <td colSpan={3}></td>
                  <td>{numeral(getInvoiceTotal(invoice)).format('$0.00')}</td>
                  <td>{numeral(getInvoiceTaxes(invoice)).format('$0.00')}</td>
                  <td>
                    <b>
                      {numeral(getInvoiceGrandTotal(invoice)).format('$0.00')}
                    </b>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-6 offset-md-6 d-grid">
          <FinalizeButton
            invoice={invoice}
            onFinalize={setInvoice}
          ></FinalizeButton>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 offset-md-6 d-grid">
          <DeleteButton invoice={invoice} onDelete={routeToHome}></DeleteButton>
        </div>
      </div>
    </div>
  )
}
